import { Readability } from "@mozilla/readability";
const corsProxyUrl = "https://cors-anywhere-odwcf2od6a-oa.a.run.app/";

export const retrieveArticle = (url, consume, setLoading, errorHandler) => {
  console.log("Retrieving article with url " + url);
  setLoading(true);

  const fetched = fetch(corsProxyUrl + url)
    .then((articleWebsite) => {
      console.log("... retrieved website");
      return articleWebsite.text();
    })

    .then((html) => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      console.log("... parsed HTML");

      let article = new Readability(doc).parse();
      console.log(
        `... extracted content: ${article.textContent.trim().substring(0, 100)}...`
      );

      consume(article.textContent);
      setLoading(false);
    })

    .catch((error) => {
      let message = "Failed to retrieve article: ";
      message += error.message
      console.log(message);
      errorHandler(message);
      setLoading(false);
      return null;
    });
};